import * as React from "react";
const TrainingContactView = React.lazy(() => import("./TrainingContactView"));

export { TrainingContactView };
